/* global app */

'use strict';

app.controller('ClientHomeCtrl', [
    '$rootScope',
    '$scope',
    function ($rootScope, $scope) {

    }
]);
